import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import image from '../../../Assets/images/404.png'
export default function NoPage() {
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>

            <img style={{margin: '100px auto',display:"block", width: "200px"}} src={image} />
        </div>
    )
}
